import React, { useEffect, useState } from 'react';
import AnnualFilings from '../AnnualFilings';

const BASE = process.env.REACT_APP_API_URL || 'http://localhost:5000';

// ─────────────────────────────────────────────────────────────────────
// LLP e-Filing — one home for every LLP Act, 2008 filing.
//   • Annual  — Form 11 & Form 8  (Phase 1, live: reuses the Annual
//               Filing engine scoped to entity_regime='LLP')
//   • Events  — Form 3 / 4 / 5 / 12 / 15 / 22-32  (Phase 2)
// ─────────────────────────────────────────────────────────────────────
export default function LlpEfiling({ onNavigate, initialCaseId }) {
  const [tab, setTab] = useState('annual');

  return (
    <div>
      <div className="mb-4">
        <p className="font-bold text-lg text-[#0f1f45]">LLP e-Filing</p>
        <p className="text-xs text-gray-400">Limited Liability Partnership Act, 2008 — annual return, statement of account & solvency, and every event-based e-form, filed and tracked from one place.</p>
      </div>

      <div className="flex items-center gap-1 mb-5 border-b border-gray-100">
        {[['annual', 'Annual (Form 11 & Form 8)'], ['events', 'Event Filings (Form 3 / 4 / 5 …)']].map(([k, label]) => (
          <button key={k} onClick={() => setTab(k)}
            className={`relative px-4 py-2.5 text-xs font-semibold ${tab === k ? 'text-[#0f1f45]' : 'text-gray-400 hover:text-gray-600'}`}>
            {label}
            {tab === k && <span className="absolute left-3 right-3 -bottom-px h-[3px] rounded" style={{ background: '#FF8400' }} />}
          </button>
        ))}
      </div>

      {tab === 'annual' && (
        <AnnualFilings entityScope="LLP" onNavigate={onNavigate} initialCaseId={initialCaseId} />
      )}
      {tab === 'events' && <LlpEventForms />}
    </div>
  );
}

function LlpEventForms() {
  const [forms, setForms] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem('token');
    fetch(`${BASE}/api/mca/llp/event-forms`, { headers: { Authorization: `Bearer ${token}` } })
      .then(r => r.json())
      .then(d => setForms(Array.isArray(d) ? d : []))
      .catch(() => setForms([]))
      .finally(() => setLoading(false));
  }, []);

  return (
    <div>
      <div className="rounded-xl border border-amber-200 bg-amber-50 px-4 py-3 mb-4">
        <p className="text-xs font-semibold text-amber-800">Event-filing engine — Phase 2</p>
        <p className="text-[11px] text-amber-700 mt-0.5">
          The per-form case workflow (checklist, resolution of partners, supplementary LLP Agreement, SRN & fee tracking, sync back to Company Master) ships next.
          Form 3 (initial agreement) and Form 4 (partner changes) are the first to be wired. The catalog below is what the engine will cover.
        </p>
      </div>

      {loading && <p className="text-xs text-gray-400 px-1">Loading catalog…</p>}
      <div className="grid grid-cols-2 gap-3">
        {forms.map(f => (
          <div key={f.form} className="bg-white rounded-xl border border-gray-100 p-4">
            <div className="flex items-center justify-between">
              <p className="text-sm font-bold text-[#0f1f45]">{f.form}</p>
              <span className="text-[10px] font-semibold text-gray-400">{f.law}</span>
            </div>
            <p className="text-xs text-gray-600 mt-1">{f.title}</p>
            {Array.isArray(f.triggers) && f.triggers.length > 0 && (
              <ul className="mt-2 space-y-0.5">
                {f.triggers.map((t, i) => (
                  <li key={i} className="text-[11px] text-gray-400 flex gap-1.5"><span className="text-gray-300">•</span>{t}</li>
                ))}
              </ul>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
